import PropTypes from 'prop-types';

export const SANS_SERIF = 'sans-serif';
export const SERIF = 'serif';

export const typographyType = PropTypes.oneOf([
  SANS_SERIF,
  SERIF,
]);
